import List from '@experimental-components/RowsInContentTable';
import { RowsProps } from '@experimental-components/RowsInContentTable/types';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface ErrorInterface {
  sheetName?: string;
  column?: string;
  columnName?: string;
  description?: string;
  errorCode?: string;
  row?: number;
  sheet?: string;
}

export const ErrorTable = ({ errors }: { errors: ErrorInterface[] }) => {
  const { t } = useTranslation();
  const rows = errors.map((error: ErrorInterface) => {
    const keys = Object.keys(error).filter((key) => key !== 'errorCode');

    const content = keys
      .map((key) => {
        if (key === 'column' && error.columnName) {
          const combinedValue = `${error?.columnName || ''} (${error?.column || ''})`.trim();
          return {
            value: combinedValue,
            type: 'text',
          };
        }
        if (key === 'columnName') {
          return null;
        }
        return {
          value: error[key as keyof ErrorInterface] || '',
          type: 'text',
        };
      })
      .filter(Boolean);

    return {
      uuid: '',
      content,
    };
  });
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <Typography variant="h6">{t('menuMaker:importMenu.error.title')}</Typography>
      <List
        fetchNextPage={() => {}}
        hasNextPage={false}
        headers={[
          {
            name: t('menuMaker:importMenu.error.tab'),
            sorting: 1,
          },
          {
            name: t('menuMaker:importMenu.error.row'),
            sorting: 1,
          },
          {
            name: t('menuMaker:importMenu.error.column'),
            tooltip: '',
            sorting: 1,
          },
          {
            name: t('menuMaker:importMenu.error.description'),
            sorting: 1,
          },
        ]}
        rows={rows as RowsProps[]}
      />
    </Box>
  );
};
